import formComponent from '@/util/proto/formComponent'
import LevelTable from './partial/level-table'

const strategyState = [{value:1,label:'启用'},{value:0,label:'禁用'}]

export default {
  extends: formComponent ,

  data() {
    return {
      formData: {
       
        name: {
          rules:[
            { required: true, message: '请输入证照名称', trigger: 'blur,change' },
          ]
        },
        codePrefix:{
          rules:[
            { required: true, message: '请输入证照编码前缀', trigger: 'blur,change'},
          ]
        },
        modelType:{
          rules:[
            { required: true, type:'number', message: '请选择证照模板', trigger: 'blur,change'},
          ]
        },
        issueTo: {
          rules:[
            { required: true, type:'number', message: '请选择发行对象', trigger: 'blur,change'},
          ]
        },
        organizationId:{
          rules:[
            { required: true, type:'number',message: '请选择机构', trigger: 'blur,change' },
          ]
        },
        scoreCycle: {
          rules:[
            { type: 'number', required: true, message: '请输入计分周期', trigger: 'blur,change' },
          ]
        },
        scoreTotal: {
          rules:[
            { type: 'number', required: true, message: '请输入周期总分', trigger: 'blur,change' },
          ]
        },
        
        strategy:null,
      },
      id:null,
      loading:false,
      visible:false,
      raw:{},
      state:{
        levels:[],
        organizationName:null,
      },
      api:['licenseCreate','licenseUpdate'],
    }
  },
  created(){

  },
  computed:{
    title(){
      return this.id ? '修改证照' : '新增证照'
    },
  },
  methods: {
    init(id) {
      this.id = id
      this.visible = true
      this.$resetFormData()
      if (this.id) {
        this.query()
      }
    },

    query(){
      this.loading = true
      this.$request.license(this.id).then(resp => {
        this.$setFormData(resp.data)
        this.raw = resp.data
        //TODO 
        this.state.levels = resp.data.strategyList

        this.loading = false
      })
    },
    handleChangeOrg(d){
      this.state.organizationName = d.label
    },
    beforeSave(d){
      let {...params} = d
      if(this.id){
        params.id = this.id
      }
      if(this.state.organizationName){
        params.organizationName = this.state.organizationName
      }
      if(params.strategy){
        params.strategyList = this.state.levels
      }
      return params
    }
  },

  render(){
    let enableLevel = this.form ? this.form.getFieldValue('strategy') : null
    let score = this.form ? this.form.getFieldValue('scoreTotal') : Number.MAX_SAFE_INTEGER
    return (
      <sl-side-panel v-model={this.visible} loading={this.loading} title={this.title} loading={this.loading}>
        <sl-form label-width={100}>
          <sl-form-item label="证照名称">
            <Input v-decorator={this.formData.name}></Input>
          </sl-form-item>
          <sl-form-item label="证照编码">
            <Input v-decorator={this.formData.codePrefix}></Input>
          </sl-form-item>
          <sl-form-item label="证照模板">
            <sl-select type="radio" dict="licenseTemplateType" v-decorator={this.formData.modelType}  />
          </sl-form-item>
          <sl-form-item label="发行对象">
            <sl-select type="radio" dict="licenseSubejctType" v-decorator={this.formData.issueTo}  />
          </sl-form-item>
          <sl-form-item label="发行机构">
            <sl-select v-decorator={this.formData.organizationId} on-change-data={this.handleChangeOrg} dict="org" />
          </sl-form-item>

          <Divider size="small" style="color:rgba(0,0,0,.65);font-size:13px;margin:24px 0 16px 0;"  orientation="left">策略设置</Divider>

          <sl-form-item label="计分周期">
            <InputNumber v-decorator={this.formData.scoreCycle} min={0} /><span style="margin-left:8px;font-size:12px;color:rgba(0,0,0,0.6);">月</span>
          </sl-form-item>
          <sl-form-item label="周期总分">
            <InputNumber v-decorator={this.formData.scoreTotal} min={0} />
          </sl-form-item>
          <sl-form-item label="启用等级管理">
            <sl-select v-decorator={this.formData.strategy} dict={strategyState} type="radio" />
          </sl-form-item>
        </sl-form>
        {
          enableLevel ? <div style="padding-left:100px">
            <LevelTable v-model={this.state.levels} total-point={score} />
          </div> : null
        }
        
        <template slot="footer">
          <Button loading={this.loading} on-click={this.$handleSubmit} type="primary">确定</Button>
        </template>
      </sl-side-panel>
    )
  }
}

const displayStrategy = d => {
  let ret = ['积分']
  if(d.strategy == 1){
    ret.push('等级')
  }
  return ret.join(';')
}
export const View = {
  data() {
    return {
      id: null,
      loading: false,
      data: {},
      visible: false,
    }
  },
  methods: {

    init(id) {
      this.id = id
      this.visible = true
      if (this.id) {
        this.query()
      }
    },

    query() {
      this.loading = true
      this.$request.license(this.id).then( resp => {
        this.loading = false
        if(resp.code == 0){
           this.data = this.$utils.conv(resp.data,{ 'releaseDatetime': 'datetime','status':'licenseState','issueTo':'licenseSubejctType','modelType':'licenseTemplateType', displayStrategy , 'state':'stateN'})
        }else{
          this.visible = false
          this.$Message.error({ content: resp.msg })
        }
      })
    },
  },
  render(){
    const { loading , data = {}} = this
    return (
      <sl-side-panel destroyOnClose={true} v-model={this.visible} mask-closable={false} title="证照详情" loading={loading}>
        <sl-detail-list col={1} label-width="100px" label-align="right" style="padding:12px;">
          <sl-detail-list-item title="证照名称">{data.name}</sl-detail-list-item>
          <sl-detail-list-item title="证照编码">{data.codePrefix}</sl-detail-list-item>
          <sl-detail-list-item title="证照模板">{data.modelTypeText}</sl-detail-list-item>
          <sl-detail-list-item title="发行对象">{data.issueToText}</sl-detail-list-item>
          <sl-detail-list-item title="发行机构">{data.organizationName}</sl-detail-list-item>
          <sl-detail-list-item title="计分周期">{data.scoreCycle}月</sl-detail-list-item>
          <sl-detail-list-item title="周期总分">{data.scoreTotal}</sl-detail-list-item>
          <sl-detail-list-item title="管理机制">{data.displayStrategy}</sl-detail-list-item>
          <sl-detail-list-item title="等级管理">
            <LevelTable v-model={data.strategyList} editable={false} />
          </sl-detail-list-item>
        </sl-detail-list>
      </sl-side-panel>
    )
  }
}